var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flag-2-svgrepo-com 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.75 16.5V10.5M3.75 10.5V3M3.75 10.5L5.603 10.1294C6.8409 9.88185 8.12408 9.9996 9.29618 10.4685C10.5664 10.9765 11.9643 11.0714 13.2915 10.7396L13.3666 10.7209C13.8061 10.611 14.0146 10.1077 13.7815 9.71917L12.611 7.76835C12.3549 7.34147 12.2268 7.12804 12.1964 6.89588C12.1838 6.79904 12.1838 6.70096 12.1964 6.60412C12.2268 6.37196 12.3549 6.15853 12.611 5.73166L13.5699 4.13349C13.8209 3.7152 13.4408 3.20229 12.9676 3.3206C11.851 3.59975 10.6748 3.51992 9.60615 3.09247L9.29618 2.96848C8.12408 2.49963 6.8409 2.38182 5.603 2.6294L3.75 3M3.75 3V1.5",
    stroke: "#1C274C",
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag);
export default __webpack_public_path__ + "static/media/flag.72b74c050dd74477b047d12fc9e902ee.svg";
export { ForwardRef as ReactComponent };